import type { CSSProperties } from "react";
import terminalInput from "assets/images/flair/terminal_input.svg";

/**
 * Decorative artwork the Input theme paints on a field's right edge. The theme
 * rule keys on `data-flair` and reads the image from `--input-flair`, so the
 * asset stays out of the theme bundle (Chakra's typings generator can't load
 * SVG imports).
 */
export const INPUT_FLAIRS = {
  terminal: terminalInput,
} as const;

export type InputFlair = keyof typeof INPUT_FLAIRS;

/**
 * Inline `style` that hands the chosen flair's image to the theme rule. Goes
 * through `style`, not `sx`: Chakra resolves `--*` keys in `sx` as theme
 * tokens and drops a `url()` value. The URL is quoted because Vite may inline
 * the asset as a `data:` URI containing quotes and parentheses.
 */
export const inputFlairStyle = (flair?: InputFlair): CSSProperties =>
  flair
    ? ({ "--input-flair": `url("${INPUT_FLAIRS[flair]}")` } as CSSProperties)
    : {};
